import { JobNumber } from "../Dashboard/DashboardFilters";

export class VendorFinalization {
}
export class VendorFinalizationDetails {
    requirementID:any;
    jobNumber:string;
    rmhName:string;
    rmhId:string;
    requirementType : string;
    jobType:string;
    brand:string;
    crop:string;
    language:string;
    state:string;
    requirementMonth:string
    finalQuantity:any;
    wHLocation:any;
    orderStatus:any;
    vendorType:any;
    isActive : boolean;
    currentStatus : number;
    year: string;
}

export class VendorFinalizationFilters {
    jobNumbers:jobNumber[];
    rmhs:RMH[];
    jobTypes:JobType[];
    brands:Brand[];
    crops:Crop[];
    languages:Language[];
    status:RequirementStatus[];
    states:State[];
    maMapping:MaMapping[];
    mapping : stateMapping[];
    rollingYears : RollingYear[];
}

export class jobNumber{
    jobNumberID:string;
    jobNumberName:string;
    rMHCode:string;
    brandID: string;
    jobTypeID:number;
    cropID:number;
    languageID:number;
    stateName: string;
    month : string
    vendorID : string;
}
export class RMH{
    rMHCode:string;
    rMHName:string;
}

export class Brand{
    brandID:string;
    brandName:string;
}

export class JobType{
    jobTypeID:number;
    jobTypeName:string;
}

export class Crop{
    cropID:number;
    cropName:string;
}

export class Language{
    languageID:number;
    languageName:string;
}

export class RequirementStatus{
    requirementStatusID:number;
    requirementStatusName:string;
}

export class State{
    stateID:string;
    stateName:string;
}

export class MaMapping{
    rMHCode:string;
    stateName:string;
    ma:string;
}

export class stateMapping{
    languageID : number;
    languageName : string;
    state : string;
}

export class RollingYear{
    year: string;
    currentrequirementYear: string;
}

export class UpdateVendorType{
    JobNumber : string;
    VendorType : string;
}

export class UpdateVendorTypeDetails{
 ID :number;
JobNumber : string;
 VendorType : number;
VendorName : string;
CurrentStatus :number;
 IsActive :number;
 Action : string;
 Date:any;
}